import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "@store"
import { getCurrentFiscalYear } from "@services/calendar"

export enum Concert {
    Autumn,
    Winter,
    Spring,
    Summer,
    Family
}

export const initialState: PageState = {
    year: getCurrentFiscalYear(),
    concert: Concert.Winter
}

export interface PageState {
    year: number,
    concert: Concert
}

export const pageStateSlice = createSlice({
    name: "pageState",
    initialState: initialState,
    reducers: {
        setYear: (state, action: PayloadAction<number>) => {
            state.year = action.payload;
        },
        setConcert: (state, action: PayloadAction<Concert>) => {
            state.concert = action.payload;
        }
    }
})

export const selectYear = (state: typeof RootState) => state.pageState.year;
export const selectConcert = (state: typeof RootState) => state.pageState.concert;
export const { setYear, setConcert } = pageStateSlice.actions;
export const pageStateReducer = pageStateSlice.reducer;
